/**
 * Clown section invisible hotspot
 *
 * Injects a 50×50px invisible link in the center of the target section that
 * redirects to https://gilga.com.
 *
 * Section is detected by:
 * 1. A block with data-clown-hotspot (add a "Custom liquid" block with
 *    <div data-clown-hotspot style="position:absolute;width:0;height:0;overflow:hidden;left:0;top:0;pointer-events:none;" aria-hidden="true"></div>)
 * 2. Or by presence of the HappyClown image (img[src*="HappyClown_Still_Alpha_004"])
 */
(function () {
  'use strict';

  const HOTSPOT_URL = 'https://gilga.com';
  const HOTSPOT_SIZE_PX = 100;

  function getTargetSection() {
    const byMarker = document.querySelector('[data-clown-hotspot]');
    if (byMarker) {
      return byMarker.closest('.shopify-section');
    }
    const section = document.querySelector('.shopify-section img[src*="HappyClown_Still_Alpha_004"]')?.closest('.shopify-section');
    return section || null;
  }

  function injectHotspot() {
    const section = getTargetSection();
    if (!section) return;

    const contentWrapper = section.querySelector('.section-content-wrapper');
    if (!contentWrapper) return;

    if (contentWrapper.querySelector('[data-clown-hotspot-link]')) return;

    const link = document.createElement('a');
    link.href = HOTSPOT_URL;
    link.setAttribute('data-clown-hotspot-link', '');
    link.setAttribute('aria-label', 'Go to homepage');
    link.style.cssText = [
      'position: absolute',
      'left: 48%',
      'top: 55%',
      'width: ' + HOTSPOT_SIZE_PX + 'px',
      'height: ' + HOTSPOT_SIZE_PX + 'px',
      'margin-left: -' + (HOTSPOT_SIZE_PX / 2) + 'px',
      'margin-top: -' + (HOTSPOT_SIZE_PX / 2) + 'px',
      'z-index: 2',
      'cursor: pointer'
    ].join('; ');

    const wrapperStyle = contentWrapper.getAttribute('style') || '';
    if (!wrapperStyle.includes('position')) {
      contentWrapper.style.position = 'relative';
    }

    contentWrapper.appendChild(link);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectHotspot);
  } else {
    injectHotspot();
  }
})();
